<script setup lang="ts">
    import { SidebarGroup } from '@/components/ui/sidebar';

    import { type NavItem, type SharedData } from '@/types';
    import { usePage } from '@inertiajs/vue3';
    import NavMenu from '@/components/NavMenu.vue';

    defineProps<{
        items: NavItem[];
    }>();

    const page = usePage<SharedData>();
</script>

<template>
    <SidebarGroup class="px-[7px] py-0">
        <NavMenu :items="items" />
    </SidebarGroup>
</template>
